// Hand-off from the build-time pre-rendered sign-in page (spec 024). scripts/prerender.mjs writes
// dist/sign-in.html with the page's first state as static HTML beside the empty React root, so
// the first paint does not wait for the JavaScript. React renders into its own root; the static
// copy is removed in a layout effect of the first real frame, before the browser paints, so the
// swap never shows a blank or doubled page. Hydration is not used: the router renders nothing
// until its guards have run, which would discard the static markup and flash an empty page.
import { useLayoutEffect } from 'react'

/** The id of the element that holds the pre-rendered page in dist/sign-in.html. */
export const PRERENDER_ID = 'prerender'

/** Removes the pre-rendered page, if any; call it from every component that frames a page. */
export function usePrerenderHandoff(): void {
  useLayoutEffect(() => {
    document.getElementById(PRERENDER_ID)?.remove()
  }, [])
}
